var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge",class:_vm.classes},[(_vm.indicator)?_c('i',{staticClass:"badge__indicator"}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"badge__label"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }